import type { UserIds } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { X } from "lucide-react";

interface UserIdsFilterProps {
  value: UserIds;
  onChange: (value: UserIds) => void;
}

export function UserIdsFilter({ value, onChange }: UserIdsFilterProps) {
  const addId = () => {
    onChange({ ...value, user_ids: [...value.user_ids, ""] });
  };

  const updateId = (index: number, id: string) => {
    const next = [...value.user_ids];
    next[index] = id;
    onChange({ ...value, user_ids: next });
  };

  const removeId = (index: number) => {
    onChange({ ...value, user_ids: value.user_ids.filter((_, i) => i !== index) });
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label>User IDs</Label>
        <Button type="button" variant="outline" size="sm" onClick={addId}>
          Add ID
        </Button>
      </div>
      {value.user_ids.map((id, i) => (
        <div key={i} className="flex items-center gap-2">
          <Input
            value={id}
            onChange={(e) => updateId(i, e.target.value)}
            placeholder="snowflake"
            className="flex-1"
          />
          <Button type="button" variant="ghost" size="icon" onClick={() => removeId(i)}>
            <X className="h-4 w-4 text-red" />
          </Button>
        </div>
      ))}
    </div>
  );
}
